// src/pages/Home.js

import React from "react";
import Hero from "./Hero";
import WhyAttorney from "./WhyAttorney";
import CallAction from "./CallAction";
import Services from "./Services";
import About from "./About";
import Contact from "./Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <WhyAttorney />
      <CallAction />
      <Services />
      <About />
      <Contact />
    </>
  );
};

export default Home;